/**
 * Models either the static matchInfo (from the fixture list API) or, once
 * available, the polled liveMatch (from cfsApi's single-match endpoint) into
 * one consistent shape.
 *
 * @param {object} matchInfo - The match object as supplied by the fixture list API.
 * @param {object} [liveMatch] - The polled single-match response, once fetched.
 * @returns {object} The normalised match object.
 */
export function normaliseMatch(matchInfo, liveMatch) {
    if (!liveMatch) {
        return {
            ...matchInfo,
            homeScore: matchInfo.home.score?.totalScore,
            awayScore: matchInfo.away.score?.totalScore,
            homeTeamAbbr: matchInfo.home.team.abbreviation.toLowerCase(),
            homeTeamPid: matchInfo.home.team.providerId,
            awayTeamAbbr: matchInfo.away.team.abbreviation.toLowerCase(),
            awayTeamPid: matchInfo.away.team.providerId
        };
    }

    return {
        ...liveMatch,
        id: matchInfo.id,
        homeScore: liveMatch.score?.homeTeamScore.matchScore.totalScore,
        awayScore: liveMatch.score?.awayTeamScore.matchScore.totalScore,
        homeTeamAbbr: liveMatch.match.homeTeam.abbr.toLowerCase(),
        homeTeamPid: liveMatch.match.homeTeamId,
        awayTeamAbbr: liveMatch.match.awayTeam.abbr.toLowerCase(),
        awayTeamPid: liveMatch.match.awayTeamId,
        utcStartTime: liveMatch.match.utcStartTime,
        status: liveMatch.match.status
    };
}
